(function () {
    const productsPerRow = () => {
        // We use .off().on() to prevent double-firing if AJAX reloads the section
        $(".per-row__button").off("click").on("click", function () {
            $(".per-row__button").removeClass("active");
            $(`[data-per-row="${$(this).data("per-row")}"]`).addClass("active");
            $("[data-productis-in-row]").attr(
                "data-productis-in-row",
                $(this).data("per-row")
            );
        });
    };

    // ADDED: This checks the screen size on page load and forces the correct 
    // default layout AND highlights the correct button instantly.
    const initDeviceDefaults = () => {
        if (window.innerWidth <= 768) {
            $(".per-row__button").removeClass("active");
            $('.per-row__button[data-per-row="large"]').addClass("active");
            $("[data-productis-in-row]").attr("data-productis-in-row", "large");
        } else {
            $(".per-row__button").removeClass("active");
            $('.per-row__button[data-per-row="small"]').addClass("active");
            $("[data-productis-in-row]").attr("data-productis-in-row", "small");
        }
    };

    document.addEventListener("shopify:section:load", function () {
        productsPerRow();
        initDeviceDefaults();
    });
    
    productsPerRow();
    initDeviceDefaults();
})();